import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { fa } from 'vuetify/iconsets/fa'
import { aliases, mdi } from 'vuetify/lib/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'flag-icons/css/flag-icons.min.css'
import 'v-phone-input/dist/v-phone-input.css'
import { createVPhoneInput } from 'v-phone-input'
import { VDateInput } from 'vuetify/labs/VDateInput'
import i18n from '@/i18n/config.js'

const { t } = i18n.global

export const vPhoneInput = createVPhoneInput({
  countryIconMode: 'svg',
  displayFormat: 'significant',
  enableSearchingCountry: true,
  label: '',
  countryLabel: '',
  defaultCountry: 'FR',
  invalidMessage: () => t('ERROR_INPUT.PHONE')
})

const theme = {
  dark: false,
  colors: {
    error: '#FF5C5C',
    warning: '#FFAC0A'
  }
}

export default createVuetify({
  locale: {
    locale: 'fr',
    fallback: 'en'
  },
  date: {
    locale: {
      fr: 'fr-FR'
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      fa
    }
  },
  theme: {
    defaultTheme: 'theme',
    themes: {
      theme
    }
  },
  defaults: {
    VAutocomplete: {
      autocomplete: 'off',
      baseColor: 'grey',
      bgColor: 'white',
      color: '#a9a9a9',
      rounded: true,
      variant: 'outlined'
    },
    VDataTable: {
      class: "custom-table",
      fixedFooter: true,
      fixedHeader: true,
      itemsPerPage: -1,
      hover: true,
      noDataText: t('COMMON.NO_DATA')
    },
    VDateInput: {
      appendInnerIcon: 'mdi-calendar',
      bgColor: 'white',
      cancelText: t('COMMON.BUTTON.CANCEL'),
      prependIcon: '',
      variant: 'outlined'
    },
    VDatePicker: {
      class: 'picker-fixed-height',
      color: 'var(--default-primary)',
    },
    VFileInput: {
      baseColor: 'grey',
      bgColor: 'white',
      color: '#a9a9a9',
      prependIcon: '',
      rounded: true,
      variant: 'outlined'
    },
    VSelect: {
      baseColor: 'grey',
      bgColor: 'white',
      clearable: true,
      color: '#a9a9a9',
      rounded: true,
      variant: 'outlined'
    },
    VTextarea: {
      baseColor: 'grey',
      bgColor: 'white',
      color: '#a9a9a9',
      rounded: true,
      variant: 'outlined'
    },
    VTextField: {
      baseColor: 'grey',
      bgColor: 'white',
      color: '#a9a9a9',
      rounded: true,
      variant: 'outlined'
    }
  },
  components: {
    ...components,
    VDateInput
  },
  directives
})
